import './sections/collection-featured-products.scss';
import './sections/collection-products.scss';
import './sections/collection-title.scss';
import { ADD_TO_CART, DISABLED, SOLD_OUT } from './config/constants';
import { openOverlay, turnOffButton, turnOnButton } from './inquire-comingsoon';
import addToCart from './utils/addToCart';
import addClass from './utils/dom/addClass';
import click from './utils/dom/click';
import clickEvent from './utils/dom/click';
import removeClass from './utils/dom/removeClass';
import formatPrice, { isPriceZero } from './utils/formatPrice';
import setupCollectionBis from './utils/setupCollectionBis';
import storefrontRequest from './utils/storefrontRequest';

const ON = 'on';
const smallSelector = '.collection--smalls';
const bigSelector = '.collection--biggie';
const gridSelector = '.collection--grid';

const products = {};

// Make products available globally for back in stock functionality
window.HMR = window.HMR || {};
window.HMR.products = products;

const inquireOverlay = document.getElementById('inquire-overlay');

document.body.appendChild(inquireOverlay);

const addProducts = (dom) => {
  const data = [...dom.querySelectorAll('.product-json')];
  data.forEach((product) => {
    try {
      const parsed = JSON.parse(product.innerHTML.replace('\n', ''));
      // Support both { product } and { products: [...] }
      if (parsed.product) {
        // Single product
        if (!products[parsed.product.id]) {
          products[parsed.product.id] = parsed.product;
        }
      } else if (Array.isArray(parsed.products)) {
        // Array of products
        parsed.products.forEach((prod) => {
          if (!products[prod.id]) {
            products[prod.id] = prod;
          }
        });
      }
    } catch (exc) {
      console.error(exc, product.innerHTML);
    }
  });
};

const getVariant = (grid) => {
  const { productid } = grid.dataset;
  const colorEl = grid.querySelector('.collection-grid-color.on');
  const sizeEl = grid.querySelector('.size-select select');

  const color = colorEl?.parentElement.dataset.color || false;
  const size = sizeEl?.value || false;

  const product = products[productid];
  const { variants } = product;

  let variant = null;
  if (colorEl && sizeEl) {
    variant = variants.find((vari) => color === vari.color && size === vari.size);
  } else if (colorEl) {
    variant = variants.find((vari) => color === vari.color);
  } else if (sizeEl) {
    variant = variants.find((vari) => size === vari.size);
  } else {
    variant = variants[0];
  }
  return { product, variant };
};

// (For debugging related product issues, you can manually inspect the relatedProduct element in the browser console if needed.)
const onAddToCart = (grid, button) => {
  const { variant } = getVariant(grid);
  const relatedProduct = grid.querySelector('.related-product');
  const additionalProduct = grid.querySelector('.additional-products');
  let additionalProductId = null;
  if (additionalProduct) {
    const select = additionalProduct.querySelector('select');
    if (select && select.value && select.value !== 'none') {
      // Extract numeric ID from Shopify GID string
      const parts = select.value.split('/');
      additionalProductId = parts[parts.length - 1];
    }
  }
  addToCart(button, variant, relatedProduct, additionalProductId);
};

const onColorChange = (target) => {
  const { root: rootID, url, variant: variantID } = target.dataset;

  const parent = target.parentElement;
  const root = document.getElementById(rootID);
  const variant = document.getElementById(variantID);

  variant.parentElement.scrollTo({
    left: variant.offsetWidth * parseInt(variant.dataset.index, 10),
  });

  // Update all links within the component to the new URL;
  const links = [...root.querySelectorAll('.collection-grid-details a')];
  links.forEach((link) => {
    link.href = url;
  });

  // Update the UI
  removeClass(parent.querySelector(`.${ON}`), ON);
  addClass(target.querySelector('div'), ON);
};

const updateGrid = (grid) => {
  const { product, variant } = getVariant(grid);

  const inquiries = grid.querySelector(`.inquire-button`);
  const soon = grid.querySelector(`.coming-soon-button`);
  const addToBag = grid.querySelector(`.add-to-bag-button`);
  const color = grid.querySelector('.collection-grid-color-detail');
  const material = grid.querySelector('.collection-grid-material');
  const stones = grid.querySelector('.collection-grid-stones');

  if (variant.color && color) {
    color.innerHTML = variant.color;
  }

  // Update material display
  if (material) {
    if (variant.material) {
      material.innerHTML = variant.material;
      material.style.display = 'block';
    } else {
      material.style.display = 'none';
    }
  }

  // Update stones display
  if (stones) {
    if (variant.stones) {
      stones.innerHTML = variant.stones;
      stones.style.display = 'block';
    } else {
      stones.style.display = 'none';
    }
  }

  if (variant.comingsoon) {
    turnOnButton(soon);
    turnOffButton(addToBag);
    turnOffButton(inquiries);

    if (soon) {
      const releaseDate = soon.querySelector('.product-release-date');
      releaseDate.innerHTML = variant.releaseDate ? variant.releaseDate : '';
    }
  } else if (product.inquiriesOnly) {
    turnOnButton(inquiries);
    turnOffButton(addToBag);
    turnOffButton(soon);
  } else {
    if (!addToBag) {
      console.info('no add to bag', variant);
      return;
    }
    turnOnButton(addToBag);
    turnOffButton(inquiries);
    turnOffButton(soon);

    const div = addToBag.querySelector('div');
    const buttonPrice = addToBag.querySelector('.product-button-price');
    const gridPrice = grid.querySelector('.collection-grid-price');
    const formattedPrice = formatPrice(variant.price, variant.id);
    const newPrice = isPriceZero(formattedPrice)
      ? ''
      : `
    <span>
      ${formattedPrice}
    </span>`;
    gridPrice.innerHTML = newPrice;
    buttonPrice.innerHTML = newPrice;

    if (variant.available && !variant.soldOut) {
      div.innerHTML = ADD_TO_CART;
      addToBag.removeAttribute(DISABLED);
      addToBag.removeAttribute('data-bis');
      addToBag.setAttribute('aria-label', `Click to add ${product.title} to your bag`);
    } else {
      // Use the back in stock label from product metafields, or fallback to default
      const backInStockLabel = product.metafields?.hmr?.back_in_stock_label || 'Sold Out - Notify me when available';
      div.innerHTML = backInStockLabel;
      // Don't disable the button for back in stock - it should still be clickable
      addToBag.removeAttribute(DISABLED);
      addToBag.setAttribute('data-bis', 'true');
      addToBag.setAttribute('aria-label', `Click to sign up for back in stock notifications for ${product.title}`);
    }
  }
};

const group = () => {
  const { displayAllVariantsInGrid, groupByColor } = window.HMR.collection;
  if (!groupByColor) {
    return;
  }

  const small = document.querySelector(smallSelector);
  const big = document.querySelector(bigSelector);
  const grid = document.querySelector(gridSelector);
  const elementsSmall = [...small.querySelectorAll('.collection-variant')];
  const elementsBig = [...big.querySelectorAll('.collection-variant-biggie')];
  const elementsGrid = [...document.querySelectorAll('.collection-grid-product')];

  const newElementsBig = [];
  const newElementsGrid = [];
  const newElementsSmall = [];

  // console.info('elementsSmall.length, elementsBig.length', elementsSmall.length, elementsBig.length);

  let colors = {};
  let idx = 0;
  elementsSmall.forEach((el, i) => {
    const color = el.dataset.color || '';
    // console.info('color', color, colors);
    let index = idx;
    if (colors[color] !== undefined) {
      index = colors[color];
      if (elementsBig[i]) {
        newElementsBig[index].push(elementsBig[i]);
      }
      if (displayAllVariantsInGrid) {
        newElementsGrid[index].push(elementsGrid[i]);
      }
      newElementsSmall[index].push(el);
    } else {
      colors[color] = index;
      if (elementsBig[i]) {
        newElementsBig.push([elementsBig[i]]);
      }
      if (displayAllVariantsInGrid) {
        newElementsGrid.push([elementsGrid[i]]);
      }
      newElementsSmall.push([el]);
      idx += 1;
    }
  });
  // console.info('colors', colors);

  if (!displayAllVariantsInGrid) {
    colors = {};
    idx = 0;
    elementsGrid.forEach((el) => {
      const color = el.dataset.color || '';
      let index = idx;

      if (colors[color] !== undefined) {
        index = colors[color];
        newElementsGrid[index].push(el);
      } else {
        colors[color] = index;
        newElementsGrid.push([el]);
        idx += 1;
      }
    });
  }

  // console.info('colors', colors);

  big.innerHTML = '';
  grid.innerHTML = '';
  small.innerHTML = '';
  newElementsBig.forEach((els) =>
    els.forEach((el) => {
      if (el) {
        big.appendChild(el);
      } else {
        console.info('cannot add to big', el);
      }
    }),
  );
  newElementsGrid.forEach((els) =>
    els.forEach((el) => {
      if (el) {
        grid.appendChild(el);
      } else {
        console.info('cannot add to grid', el);
      }
    }),
  );
  newElementsSmall.forEach((els) =>
    els.forEach((el) => {
      if (el) {
        small.appendChild(el);
      } else {
        console.info('cannot add to small', el);
      }
    }),
  );
};

const addToCartHandler = (grid, button) => (event) => {
  if (event) event.preventDefault();
  onAddToCart(grid, button);
};

const setupGrid = () => {
  group();
  // Remove duplicate .collection-grid-product elements by data-productid after group() manipulates the DOM
  const seen = new Set();
  document.querySelectorAll('.collection-grid-product').forEach((el) => {
    const pid = el.dataset.productid;
    if (seen.has(pid)) {
      el.parentNode && el.parentNode.removeChild(el);
    } else {
      seen.add(pid);
    }
  });
  // This is duplicated in application.js
  // Scroll to the current variant image
  const currents = [...document.querySelectorAll('.collection-grid-img.current')];
  currents.forEach((current) => {
    current.parentElement.scrollTo({
      left: current.offsetWidth * parseInt(current.dataset.index, 10),
    });
  });

  // Add click events to all the color buttons
  const colors = [...document.querySelectorAll('.collection-grid-colors')];
  colors.forEach((color) => {
    const buttons = [...color.querySelectorAll('button')];
    if (buttons.length > 1) {
      [...buttons].forEach((butt) => {
        butt.addEventListener(click(), () => {
          onColorChange(butt);
        });
      });
    }
  });

  const grids = [...document.querySelectorAll('.collection-grid-product')];
  grids.forEach((grid) => {
    const addToBag = grid.querySelector('.add-to-bag-button');
    const sizeSelect = grid.querySelector('.size-select');
    const inquireButton = grid.querySelector('.inquire-button');
    const comingSoonButton = grid.querySelector('.coming-soon-button');

    const previous = grid.querySelector('.collection-grid-product-nav--prev');
    const next = grid.querySelector('.collection-grid-product-nav--next');

    if (previous && next) {
      const move = (direction) => {
        const images = grid.querySelector('.collection-grid-imgs');
        const kids = images.querySelectorAll('.collection-grid-img');
        const buttons = [...grid.querySelectorAll('.collection-grid-colors button')];
        const current = grid.querySelector('[aria-checked="true"]');
        const index = buttons.indexOf(current);

        images.scrollTo({ left: kids[0].offsetWidth * (index + direction), behavior: 'smooth' });
      };
      next.addEventListener(clickEvent(), () => {
        move(1);
      });
      previous.addEventListener(clickEvent(), () => {
        move(-1);
      });
    }

    if (addToBag) {
      // Remove any previous event listener before adding
      addToBag.replaceWith(addToBag.cloneNode(true));
      const newAddToBag = grid.querySelector('.add-to-bag-button');

      // Unified event handler for both add-to-cart and back-in-stock
      newAddToBag.addEventListener(clickEvent(), (event) => {
        // Check if this is a back in stock button
        if (newAddToBag.dataset.bis === 'true') {
          // Let the back in stock handler deal with it
          return;
        }
        // Otherwise, handle as add to cart
        addToCartHandler(grid, newAddToBag)(event);
      });
    }

    if (sizeSelect) {
      sizeSelect.addEventListener('change', () => {
        updateGrid(grid);
      });
    }

    if (inquireButton) {
      inquireButton.addEventListener(clickEvent(), () => {
        const { product, variant } = getVariant(grid);
        openOverlay(product, variant, inquireButton);
      });
    }

    if (comingSoonButton) {
      comingSoonButton.addEventListener(clickEvent(), () => {
        const { product, variant } = getVariant(grid);
        openOverlay(product, variant, comingSoonButton);
      });
    }

    // Initialize back in stock functionality for this product
    const variantData = getVariant(grid);
    if (variantData.variant) {
      // Get the current button (after cloning) and set up back in stock functionality
      const currentAddToBag = grid.querySelector('.add-to-bag-button');
      if (currentAddToBag) {
        setupCollectionBis(variantData);
      }
    }
  });

  // Listen to scroll events to update the color swatches on scroll
  const scrollers = [...document.querySelectorAll('.collection-grid-imgs')];
  scrollers.forEach((scroller) => {
    const kids = scroller.querySelectorAll('.collection-grid-img');
    if (kids.length === 1) {
      return;
    }
    const onScroll = (event) => {
      const { target } = event;
      let atSnappingPoint = target.scrollLeft % target.offsetWidth === 0;
      let timeout = atSnappingPoint ? 0 : 150;

      clearTimeout(target.scrollTimeout);

      target.scrollTimeout = setTimeout(() => {
        const index = Math.round(target.scrollLeft / kids[0].offsetWidth);
        const buttons = target.parentElement.querySelectorAll('.collection-grid-colors button');
        const current = scroller.parentElement.querySelector(`[aria-checked="true"]`);
        const butt = buttons[index];
        const { root } = butt.dataset;
        const previous = target.parentElement.querySelector('.collection-grid-product-nav--prev');
        const next = target.parentElement.querySelector('.collection-grid-product-nav--next');

        removeClass(current.querySelector('div'), ON);
        current.setAttribute('aria-checked', 'false');

        addClass(butt.querySelector('div'), ON);
        butt.setAttribute('aria-checked', 'true');

        if (index === 0) {
          removeClass(previous, ON);
        } else {
          addClass(previous, ON);
        }

        if (index === buttons.length - 1) {
          removeClass(next, ON);
        } else {
          addClass(next, ON);
        }

        updateGrid(document.getElementById(root));
      }, timeout);
    };

    scroller.addEventListener('scroll', onScroll);
  });

  const small = document.querySelector(smallSelector);
  const big = document.querySelector(bigSelector);
  const grid = document.querySelector(gridSelector);
  removeClass(big, 'loading');
  removeClass(grid, 'loading');
  removeClass(small, 'loading');
};

// Call addProducts on initial page load to populate products object
addProducts(document);

// Call setupGrid on initial page load to initialize grid events and UI
setupGrid();

// --- INFINITE SCROLL RE-IMPLEMENTATION START ---
let isLoadingNextPage = false;

async function loadCollectionPage(url) {
  if (isLoadingNextPage) return;
  isLoadingNextPage = true;
  try {
    const response = await fetch(url);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');

    // Append new products to each collection container
    const small = document.querySelector(smallSelector);
    const big = document.querySelector(bigSelector);
    const grid = document.querySelector(gridSelector);
    const newSmall = doc.querySelector(smallSelector);
    const newBig = doc.querySelector(bigSelector);
    const newGrid = doc.querySelector(gridSelector);
    if (newSmall) small.innerHTML += newSmall.innerHTML;
    if (newBig) big.innerHTML += newBig.innerHTML;
    if (newGrid) grid.innerHTML += newGrid.innerHTML;

    // Add new products to the products object
    addProducts(doc);
    // Re-initialize event handlers/UI for new elements
    setupGrid();

    // Initialize back in stock functionality for new products
    const newGrids = [...doc.querySelectorAll('.collection-grid-product')];
    newGrids.forEach((grid) => {
      const variantData = getVariant(grid);
      if (variantData.variant) {
        setupCollectionBis(variantData);
      }
    });

    // Check for next page
    const currentNextPageLink = document.getElementById('next-collection-page');
    const newNextPageLink = doc.getElementById('next-collection-page');

    if (newNextPageLink) {
      currentNextPageLink.href = newNextPageLink.href;
    } else {
      // No more pages
      if (currentNextPageLink) {
        currentNextPageLink.remove();
      }
      window.removeEventListener('scroll', infiniteScrollHandler);
    }
  } catch (err) {
    // Optionally, handle error (show message, etc.)
    console.error('Error loading next collection page:', err);
  } finally {
    isLoadingNextPage = false;
  }
}

function infiniteScrollHandler() {
  // Trigger when user is near the bottom (e.g., 1000px from bottom)
  if (isLoadingNextPage) return;
  const scrollPosition = window.innerHeight + window.scrollY;
  const threshold = document.body.offsetHeight - 1000;
  if (scrollPosition >= threshold) {
    const nextPage = document.getElementById('next-collection-page');
    if (nextPage) {
      loadCollectionPage(nextPage.href);
    }
  }
}

// Attach infinite scroll only if there is a next page
if (document.getElementById('next-collection-page')) {
  window.addEventListener('scroll', infiniteScrollHandler);
}
// --- INFINITE SCROLL RE-IMPLEMENTATION END ---
